import React, { useCallback, useEffect, useState } from "react";
import ChildTransaction from "../../Modals/Payment/ChildTransaction/ChildTransaction";
import { useDispatch, useSelector } from "react-redux";
import {
  walletChildTransaction,
  walletContractApi,
} from "../../../Services/Payments/PaymentApi";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";
import Styles from "./Contracts.module.css";
import DetailHeader from "../DetailsHeader/DetailHeader";
import { formatDateType } from "../../../commons/FormatDate";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { walletTransaction } from "../../../Redux/Slices/paymentSlice";
import LoadMorePagination from "../../LoadeMore";

const Contracts = ({ walletId: walletIdProp, entityType }) => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();

  const activeRole = entityType || role;

  const [contracts, setContracts] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [childTransaction, setChildTransaction] = useState([]);
  const [parentData, setParentData] = useState({});
  const dispatch = useDispatch();
  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  const activeWalletId = walletIdProp || wallet?.id;

  useEffect(() => {
    dispatch(walletTransaction({ page: page, size: 20 }));
  }, [dispatch, page]);

  const fetchContracts = useCallback(async (walletId, currentPage) => {
    if (!walletId) return;
    setLoading(true);
    try {
      const res = await walletContractApi({
        id: walletId,
        page: currentPage,
        size: 20,
      });
      if (res?.data?.code === 200) {
        const newData = res.data.data?.page || [];
        setContracts((prev) =>
          currentPage === 0 ? newData : [...prev, ...newData],
        );
        const { totalPages, currentPage: cp } = res.data.data;
        setHasMore(cp < totalPages - 1);
      } else {
        if (currentPage === 0) setContracts([]);
        setHasMore(false);
      }
    } catch {
      if (currentPage === 0) setContracts([]);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setContracts([]);
    setPage(0);
    setHasMore(false);
  }, [activeWalletId]);

  useEffect(() => {
    fetchContracts(activeWalletId, page);
  }, [activeWalletId, page, fetchContracts]);

  const handleLoadMore = () => setPage((prev) => prev + 1);

  const handleChildTransaction = async (data) => {
    setParentData(data);
    let res = await walletChildTransaction(data?.id);
    if (res?.data?.code === 200) {
      setChildTransaction(res?.data?.data || []);
    } else {
      ErrorMessage(res?.data?.message || "Something went wrong");
    }
  };

  const handleSelect = () => {};

  return (
    <>
      {
        <ChildTransaction
          open={childTransaction?.length > 0}
          handleClose={() => setChildTransaction([])}
          data={childTransaction}
          parentData={parentData}
        />
      }
      <div style={{ width: "100%", height: "100%" }}>
        <DetailHeader
          heading={"Contracts"}
          handleSelect={handleSelect}
          list={
            [
              // { name: "All", value: "all", status: true },
              // { name: "Ongoing", value: "ongoing", status: false },
              // { name: "Completed", value: "completed", status: false },
              // { name: "Pending", value: "pending", status: false },
            ]
          }
        />
        <div className={Styles.tableMainElem}>
          <div
            className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
          >
            <div style={{ width: "10%" }}>Contract Id</div>
            <div style={{ width: "10%" }}>Self Listing</div>
            <div style={{ width: "10%" }}>Counterparty</div>
            <div style={{ width: "10%" }}>Start and End Date</div>
            <div style={{ width: "10%" }}>Total Contract Value (₹)</div>
            <div style={{ width: "10%" }}>Amount Blocked (₹)</div>
            <div style={{ width: "10%" }}>Total Contract Schedule (MWH)</div>
            <div style={{ width: "10%" }}>Actual Delivery (MWH)</div>
            <div style={{ width: "10%" }}>Schedule</div>
            <div style={{ width: "5%" }}>Details</div>
          </div>
          <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            >
              {contracts?.map((ele) => (
                <div className="display_flex_row tableDetails">
                  <div style={{ width: "10%" }}>
                    {ele?.bilateralContractUniqueId || "-"}
                  </div>
                  <div style={{ width: "10%" }}>
                    {(activeRole === "consumer"
                      ? ele?.name?.split("-")?.[0]?.includes("C")
                        ? ele?.name?.split("-")?.[0]
                        : ele?.name?.split("-")?.[1]
                      : ele?.name?.split("-")?.[1]?.includes("G")
                        ? ele?.name?.split("-")?.[1]
                        : ele?.name?.split("-")?.[0]
                    )?.split("_")?.[0] || "-"}
                  </div>
                  <div style={{ width: "10%" }}>
                    {activeRole === "consumer"
                      ? `${ele?.generatorName || "-"}`
                      : activeRole === "generator"
                        ? `${ele?.consumerName || "-"}`
                        : `${ele?.consumerName}-${ele?.generatorName}`}
                  </div>
                  <div style={{ width: "10%" }}>
                    {`${formatDateType(ele?.startDate)} to ${formatDateType(
                      ele?.endDate,
                    )}`}
                  </div>
                  <div style={{ width: "10%" }}>
                    {(ele?.scheduledAmount || 0)?.toFixed(2)}
                  </div>
                  <div style={{ width: "10%" }}>
                    {(ele?.amountBlocked || 0)?.toFixed(2)}
                  </div>
                  <div style={{ width: "10%" }}>
                    {(ele?.scheduledVolume || 0)?.toFixed(2)}
                  </div>
                  <div style={{ width: "10%" }}>
                    {(ele?.deliveredVolume || 0)?.toFixed(2)}
                  </div>
                  <div
                    style={{ width: "10%" }}
                    className={`${
                      ele?.status === "COMPLETED"
                        ? "accepted"
                        : ele?.status === "PENDING"
                          ? "pending"
                          : "rejected"
                    }`}
                  >
                    {ele?.status === "COMPLETED"
                      ? "Completed"
                      : ele?.status === "PENDING"
                        ? "Ongoing"
                        : "Rejected"}
                  </div>
                  <div
                    style={{ width: "5%" }}
                    onClick={() => {
                      handleChildTransaction(ele);
                    }}
                  >
                    <VisibilityIcon
                      style={{ fontSize: "14px", color: "#f1935c" }}
                    />
                  </div>
                </div>
              ))}
            </LoadMorePagination>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contracts;
